/*
 * CMP-004 Button — Phase A1. Two jobs, no dependencies:
 * 1) Block activation of aria-disabled buttons/links and of any button whose data-state is "loading"
 *    (loading keeps focus, so the browser would still fire click on Enter/Space and follow links).
 *    Runs in the capture phase, so it also covers hosts that only flip data-state.
 * 2) Keep the polite live region in sync when a host only changes data-state at runtime.
 */
(function () {
  if (window.ncButtonInitialized) return;
  window.ncButtonInitialized = true;

  document.addEventListener('click', function (event) {
    var el = event.target.closest && event.target.closest('.nc-button[aria-disabled="true"], .nc-button[data-state="loading"]');
    if (!el) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  var STATE_CLASS = { loading: 'loading', success: 'success', error: 'error' };

  function sync(button) {
    var live = button.querySelector('[data-nc-button-live]');
    if (!live) return;
    var kind = STATE_CLASS[button.getAttribute('data-state')];
    var overlay = kind ? button.querySelector('.nc-button__overlay--' + kind) : null;
    live.textContent = overlay ? overlay.textContent.trim() : '';
    if (kind === 'loading') {
      button.setAttribute('aria-busy', 'true');
      if (button.getAttribute('aria-disabled') !== 'true') {
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('data-nc-loading-lock', '');
      }
    } else {
      button.removeAttribute('aria-busy');
      if (button.hasAttribute('data-nc-loading-lock')) {
        button.removeAttribute('aria-disabled');
        button.removeAttribute('data-nc-loading-lock');
      }
    }
  }

  if (typeof MutationObserver === 'undefined') return;
  new MutationObserver(function (records) {
    records.forEach(function (r) { if (r.target.classList && r.target.classList.contains('nc-button')) sync(r.target); });
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['data-state'] });
})();
